import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('otoken'); //"fsdfsdfsdggfdgdfg";//localStorage.getItem('token'); // or use context/state

  return isLoggedIn ? children : <Navigate to="/" />;
};

export default PrivateRoute;
